import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';

interface Props {
    count: number;
    onClose: () => void;
}

const MeetingParticipantsListHeader = ({ count, onClose }: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="flex items-center justify-between px-6 py-3 text-base font-bold">
            <span>
                {count > 0
                    ? i18next.t(
                          'videoconference.participant_list.in_meeting_count',
                          { count },
                      )
                    : i18next.t('videoconference.participant_list.in_meeting')}
            </span>
            <button
                className="flex cursor-pointer items-center border-none bg-transparent p-0"
                onClick={onClose}
                aria-label="Close participants list"
            >
                <Icon iconKey={'close'} />
            </button>
        </div>
    );
};

export default MeetingParticipantsListHeader;
